module.exports = __webpack_public_path__ + "static/media/bursts_09.be8a10ac.svg";